import React from 'react';
import { BsArrowRight } from 'react-icons/bs';
import { useDispatch } from 'react-redux';
import { Icon, IconButton } from '@chakra-ui/react';

import { hideTray } from '../../../../../../../redux/modules/tray';

const CloseArrow = () => {
  const dispatch = useDispatch();

  return (
    <IconButton
      aria-label="Hide Tray"
      icon={<Icon as={BsArrowRight} boxSize="32px" />}
      ml={6}
      mt={3}
      p={0}
      size="sm"
      textAlign="left"
      variant="textGrey"
      w="32px"
      onClick={() => dispatch(hideTray())}
    />
  );
};

export default CloseArrow;
